import cx from 'classnames'
import { useRef } from 'react'

import { Search } from '../filters/icons/search'

import styles from './input.module.css'

interface SearchInputProps {
  placeholder: string
  onChange?: (value: string) => void
  value: string
}

export function SearchInput ({ placeholder, onChange, value }: SearchInputProps): JSX.Element {
  let inputRef = useRef<HTMLInputElement>(null)

  return (
    <div
      className={styles.searchWrapper}
      onClick={() => inputRef?.current?.focus()}
    >
      <button className={cx(styles.searchIcon)}>
        <Search />
      </button>

      <input
        ref={inputRef}
        type='search'
        className={styles.search}
        placeholder={placeholder}
        onChange={(e) => onChange?.(e.target.value)}
        value={value}
      />
    </div>
  )
}
